import moment from 'moment'

export const saveToken = (token) => {
  window.localStorage.setItem('login_date', moment().format('YYYY-MM-DD'))
  window.localStorage.setItem('token', token)
}

export const setUser = user => {
  window.localStorage.setItem('userSettings', '')
  window.localStorage.setItem('user', JSON.stringify(user))
}
